import styled from 'styled-components';
import svgItem from '../../assets/onboarding/mysafety-seperator.svg';

const MySafety = styled(svgItem as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '17rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.black.base};
`;

export default MySafety;
